<template>
    <el-dialog
            :title="title"
            :visible="showBrand"
            :close-on-click-modal="!showBrand"
            :before-close="close"
            width="600px"
    >
        <div class="Brand">
            <el-form ref="form" :model="BrandModel" label-width="120px" :rules="rules">
                <el-form-item label="品牌名称" prop="brandName">
                    <el-input v-model.trim="BrandModel.brandName" maxlength="100" placeholder="请输入品牌名称" class="edit_input" style="width: 410px"></el-input>
                </el-form-item>
                <el-form-item label="品牌英文名" prop="pinyin">
                    <el-input v-model.trim="BrandModel.pinyin" maxlength="100" placeholder="请输入品牌英文名" class="edit_input" style="width: 410px"></el-input>
                </el-form-item>
                <el-form-item label="官方链接" prop="brandWebsite">
                    <el-input v-model.trim="BrandModel.brandWebsite" maxlength="100" placeholder="请输入官方链接" class="edit_input" style="width: 410px"></el-input>
                </el-form-item>
                <el-form-item label="品牌介绍" prop="brandIntroduce" class="m-t-20">
                    <el-input type="textarea" v-model.trim="BrandModel.brandIntroduce" maxlength="1000" placeholder="请输入介绍，不超过1000字" class="edit_input" style="width: 410px"></el-input>
                </el-form-item>
                <el-form-item label="Logo" prop="brandImage" class="mask m-t-20">
                    <el-upload
                            :action="url"
                            list-type="picture-card"
                            accept=".jpg,.png,.gif"
                            :file-list="fileList"
                            :limit="imgLimitNum"
                            :before-upload="beforeAvatarUpload"
                            :on-exceed="handlePicOutLimit"
                            :on-preview="handlePictureCardPreview"
                            :on-remove="handleRemove"
                            :on-success="successUpload"
                            :class="{hide:hideUpload}">
                        <i class="el-icon-plus"></i>
                    </el-upload>
                    <span class="tips">支持jpg、png、gif格式，大小不超过2M</span>
                </el-form-item>
            </el-form>
            <div class="dialog-footer" style="text-align: center;margin-top: 50px;" slot="footer">
                <el-button type="primary" @click="push('form')">确认</el-button>
            </div>
        </div>
        <el-dialog :visible.sync="dialogVisible" :close-on-click-modal="false" :append-to-body="true">
            <img width="100%" :src="dialogImageUrl" alt="" />
        </el-dialog>
    </el-dialog>
</template>

<script>
    import { addbrand,editbrand } from "@/service/dataFrame";
    import { getStorageUserRoleId } from '@/utils/store'
    import apiEnv from "@/service/apiEnv.js";
    export default {
        name: "addBrand",
        props:{
            currentParam:{
                type:Object,
                default(){return {}}
            }
        },
        data(){
            const valbrandlogo = (rule, value, callback) => { // 图片验证
                if (!this.BrandModel.brandImage) {
                    callback(new Error('Logo不能为空!'));
                } else {
                    callback();
                }
            }
            return{
                showBrand:true,
                rules:{
                    brandName: [{required:true, message: '请输入品牌名称！', trigger: 'blur'}],
                    pinyin: [{required:true, message: '请输入品牌英文名！', trigger: 'blur'}],
                    // brandWebsite: [{required:true, message: '请输入官方链接！', trigger: 'blur'}],
                    // brandIntroduce: [{required:true, message: '请输入品牌介绍！', trigger: 'blur'}],
                    brandImage:[{required:true,validator:valbrandlogo, trigger: 'change'}]
                },
                BrandModel:{
                    brandName:"",//必传
                    pinyin:"",
                    brandWebsite:"",
                    brandIntroduce:"",//必传
                    brandImage:""
                },
                url: apiEnv.uploadURL,
                imgLimitNum:1,
                fileList:[],
                dialogVisible:false,
                dialogImageUrl: "",     //点击查看的url
                hideUpload:false,
                title: '新增品牌'
            }
        },
        methods:{
            push(){
                this.$refs['form'].validate((valid) => {
                    if(valid){
                        if(this.currentParam.update == -1) {
                            let param={
                                brandImage:this.BrandModel.brandImage,
                                brandIntroduce:this.BrandModel.brandIntroduce?this.BrandModel.brandIntroduce:null,
                                brandName:this.BrandModel.brandName,
                                brandWebsite:this.BrandModel.brandWebsite?this.BrandModel.brandWebsite:null,
                                pinyin:this.BrandModel.pinyin,
                                userId:getStorageUserRoleId()
                            }
                            addbrand(param).then((res)=>{
                                if(res.Result != 1) {
                                    return this.$message.error(res.Message)
                                }
                                this.$emit("close")
                                this.$message.success("新增成功")
                                this.$emit("refreshList")
                            })
                        }else {
                            let param={
                                brandId: this.currentParam.id,
                                brandImage: this.BrandModel.brandImage,
                                brandIntroduce:this.BrandModel.brandIntroduce?this.BrandModel.brandIntroduce:null,
                                brandName:this.BrandModel.brandName,
                                brandWebsite:this.BrandModel.brandWebsite?this.BrandModel.brandWebsite:null,
                                pinyin:this.BrandModel.pinyin,
                                userId:getStorageUserRoleId()
                            }
                            editbrand(param).then(res=>{
                                if(res.Result != 1) {
                                    return this.$message.error(res.Message)
                                }
                                this.$emit("close")
                                this.$message.success("修改成功")
                                this.$emit("refreshList")
                            })
                        }
                    }
                })
            },
            close(){
                this.$emit("close")
            },
            beforeAvatarUpload(file){
                var file_ext = file.name.substring(file.name.lastIndexOf(".") + 1);//获取后缀
                file_ext = file_ext.toLowerCase(); //都改成小写
                const isJPEG = file_ext === 'pdf' || file_ext ==='jpg' || file_ext ==='gif' || file_ext === 'png'
                const isLt2M = file.size / 1024 / 1024 < 2,
                    limitStr = ['《','》','%','#','*',";","[","]","【","】",'{','}',"&","$"],
                    bool = limitStr.find((x)=>{return file.name.indexOf(x)>-1})?false:true;
                if (!isJPEG) {
                    this.$message.error('请上传正确的文件格式');
                }
                if (!isLt2M) {
                    this.$message.error('上传图片大小不能超过 2MB!');
                }
                if(!bool){
                    this.$message.error('图片命名不得包含非法字符!');
                }
                return isLt2M && bool && isJPEG;
            },
            handlePicOutLimit(){
                this.$message.warning("最多只能上传一张图片哦！")
            },
            handlePictureCardPreview(file) {
                this.dialogImageUrl = "";
                this.dialogImageUrl = file.response ?
                    file.response.Data[0].imgUrl :
                    file.url;
                this.dialogVisible = true;
            },
            handleRemove(file, fileList) {
                this.BrandModel.brandImage = ''
                this.$refs.form.validateField(['brandImage'])
                this.hideUpload = false;
                console.log(file, fileList);
            },
            successUpload(res){
                if(res.Result != 1) {
                    this.fileList = []
                    this.$refs.form.validateField('brandImage');
                    return this.$message.error(res.Message)
                }
                let simageUrl =res.Data[0].imgUrl
                this.BrandModel.brandImage =simageUrl;
                this.$refs.form.clearValidate('brandImage');
                this.hideUpload = true;
            },
        },
        mounted() {
            if(this.currentParam){
                const param = JSON.parse(JSON.stringify(this.currentParam));
                if(param.update == 1) {
                    this.$nextTick(()=> {
                        this.title = '修改品牌'
                        this.BrandModel= {
                            brandName: param.brandName,
                            pinyin: param.pinyin,
                            brandWebsite: param.brandWebsite,
                            brandIntroduce: param.brandIntroduce,
                            brandImage: param.brandImage,
                        }
                        this.fileList = [{'url':param.brandImage}]
                        this.hideUpload = true
                    })
                }
           }
        }
    }
</script>

<style lang="scss">
  .Brand{
      .el-textarea__inner{
          min-height: 120px!important;
      }
      .hide .el-upload--picture-card {
          display: none;
      }
      .m-t-20{
          margin-top: 20px;
      }
      .el-form-item{
          margin-bottom: 22px!important;
      }
  }
</style>
